import { buildStoredZip } from '~/shared/utils/store-zip';

export const WITNESS_CONNECTOR_PATH = '/downloads/asenion-witness-mcp.js';

export interface WitnessExtensionInput {
  // The platform's /guardian/mcp front door; the extension never learns the runtime's address.
  mcpUrl: string;
  projectId: string;
  projectName: string;
}

// The connection key is the one value the user supplies, so Claude Desktop keeps it in the system keychain.
export function witnessExtensionManifest(
  input: WitnessExtensionInput
): Record<string, unknown> {
  return {
    manifest_version: '0.3',
    name: `asenion-witness-${input.projectId}`,
    display_name: `Asenion Witness: ${input.projectName}`,
    version: '1.0.0',
    description: `Policy guidance and witness records for the ${input.projectName} project.`,
    author: { name: 'Asenion' },
    server: {
      type: 'node',
      entry_point: 'server/index.js',
      mcp_config: {
        command: 'node',
        args: ['${__dirname}/server/index.js'],
        env: {
          ASENION_URL: input.mcpUrl,
          ASENION_PROJECT_ID: input.projectId,
          ASENION_CREDENTIAL: '${user_config.connection_key}',
        },
      },
    },
    user_config: {
      connection_key: {
        type: 'string',
        title: 'Connection key',
        description:
          'Paste the connection key Fairly showed you when you connected this project.',
        sensitive: true,
        required: true,
      },
    },
    compatibility: {
      platforms: ['darwin', 'win32'],
      runtimes: { node: '>=16.0.0' },
    },
  };
}

export function buildWitnessExtension(
  connectorScript: string,
  input: WitnessExtensionInput
): Uint8Array {
  const encoder = new TextEncoder();
  return buildStoredZip([
    {
      name: 'manifest.json',
      data: encoder.encode(
        `${JSON.stringify(witnessExtensionManifest(input), null, 2)}\n`
      ),
    },
    { name: 'server/index.js', data: encoder.encode(connectorScript) },
  ]);
}

export function witnessExtensionFileName(projectName: string): string {
  const slug = projectName
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40);
  return `asenion-witness-${slug || 'project'}.mcpb`;
}
